import http from "/src/httpRequest.js";
export default {
  actions: {
    async getOperations(context) {
      const response = await http.get("operations");
      context.commit("setOperations", response.data);
    },
  },
};
